import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import moment from 'moment';
import * as Sentry from '@sentry/browser';
import Icon from '@/components/OfflineIcon.vue';
import '@/assets/whereisstudent.css';
import loadEverything from './loadEverything';

moment.updateLocale('en', {
    week: {
        dow: 1,
    },
})

async function boot() {
    const app = createApp(App)
    app.use(router)
    // <Icon icon="collection:name"> is used app-wide; register the offline wrapper
    // globally (it resolves from the bundled icons.js — no api.iconify.design calls).
    app.component('Icon', Icon)

    // Real error reporting. The @sentry/vite-plugin (see vite.config) already
    // uploads sourcemaps for the speedy-js project at build time; until now nothing
    // called Sentry.init(), so those maps pointed at an SDK that never ran. The DSN
    // comes from the build env (VITE_SENTRY_DSN) rather than being committed; when
    // it's unset — e.g. local dev — Sentry simply stays off.
    const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
    if (sentryDsn) {
        Sentry.init({ dsn: sentryDsn });
        // Route Vue's own render/lifecycle errors to Sentry too (the default
        // handler only logs them to the console).
        app.config.errorHandler = (err, instance, info) => {
            Sentry.captureException(err, { extra: { info } });
            console.error(err);
        };
    }

    // Opt-in local fixture. Set VITE_USE_FIXTURE=true (e.g. in a gitignored
    // .env.local) to load the v10 fixture and skip the MSAL/SharePoint path
    // entirely. OFF by default — even `npm run dev` runs the real MSAL popup +
    // SharePoint download, exactly like production, so the default dev experience
    // matches what users get. The flag exists for environments that can't perform an
    // interactive MSAL login (CI, automated screenshots). The import.meta.env.DEV
    // guard keeps the fixture tree-shaken out of the production bundle regardless of
    // the flag's value at build time.
    if (import.meta.env.DEV && import.meta.env.VITE_USE_FIXTURE === 'true') {
        try {
            const mod = await import('../fixtures/dev-fixture.json')
            loadEverything(mod.default)
        } catch (e) {
            console.warn('dev fixture not loaded; app will require login', e)
        }
    }

    app.mount('#app')
}

boot()
